import {
  Banknote,
  CreditCard,
  Smartphone,
  Building2,
  FileCheck,
} from 'lucide-react'

// Payment method display config
export const PAYMENT_METHODS = [
  { key: 'cash', label: 'Efectivo', icon: Banknote },
  { key: 'card', label: 'Tarjeta', icon: CreditCard },
  { key: 'sinpe', label: 'SINPE', icon: Smartphone },
  { key: 'transfer', label: 'Transferencia', icon: Building2 },
  { key: 'check', label: 'Cheque', icon: FileCheck },
] as const

export interface PaymentMethodBreakdown {
  cash: number
  card: number
  sinpe: number
  transfer: number
  check: number
}

export interface PaymentSummary {
  sales_by_method: PaymentMethodBreakdown
  total_credit_sales: number
  deposits_by_method: PaymentMethodBreakdown
  total_deposits: number
  total_sales: number
  total_devolutions: number
  noncash_devolutions?: number
  // Efectivo esperado y su desglose, calculados por el backend: es la cifra contra
  // la que el cierre registra la diferencia, así que no se recalcula en pantalla.
  drawer_initial: number
  drawer_cash_sales: number
  drawer_cash_deposits: number
  drawer_cash_devolutions: number
  drawer_expenses: number
  expected_cash: number
}

// Helper to check if a breakdown has any non-zero values
export const hasNonZeroMethods = (breakdown: PaymentMethodBreakdown | undefined) =>
  breakdown && PAYMENT_METHODS.some((m) => (breakdown[m.key] || 0) > 0.01)
